import React from 'react';
import PropTypes from 'prop-types';
import { handleChange } from '../../form/FormNumber/FormNumber';

const DayMonthYearInput = (props) => {
  const { name, className, placeholder, min, max, maxLength, input, meta, meta: { touched, error } } = props;
  const errorClass = meta && touched && error ? 'form-text-error ' : '';
  return (
    <input
      className={`${errorClass}input form-control ${className}`}
      name={name}
      type="number"
      placeholder={placeholder}
      min={min}
      max={max}
      {...input}
      onChange={e => handleChange(e, maxLength, input)}
    />
  );
};

DayMonthYearInput.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default DayMonthYearInput;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/DayMonthYear/DayMonthYearInput.js
 **/